<template>
  <div class="employee">
    <div class="employee__wrapper" v-if="currentEmployee">
      <div class="employee__user">
        <!-- <div class="employee__user-img">
          <img :src="require('@/assets/img/boy.svg')" alt />
        </div> -->
        <md-field>
          <label>Nombre completo</label>
          <md-input :value="fullName" disabled></md-input>
          <!-- <span class="md-error" v-if="!$v.nombres.required">Nombres son requeridos</span> -->
          <!-- <span class="md-error" v-if="!$v.nombres.isAlpha">Nombres debe contener solo letras</span> -->
        </md-field>
        <md-field>
          <label
            >Documento de Identidad :
            {{ documentTypes[currentEmployee.tregister.documentType] }}</label
          >
          <md-input :value="currentEmployee.tregister.documentNumber" disabled></md-input>
          <!-- <span class="md-error" v-if="!$v.document.required">Documento es requerido</span> -->
          <!-- <span class="md-error" v-if="!$v.document.numeric">Solo se admite números</span> -->
        </md-field>

        <md-field>
          <label>Teléfono</label>
          <md-input :value="currentEmployee.tregister.phone" disabled></md-input>
          <!-- <span class="md-error" v-if="!$v.phone.required">Teléfono es requerido</span> -->
          <!-- <span class="md-error" v-if="!$v.phone.isPhone">Debe iniciar con 9 y tener 9 dígitos</span> -->
        </md-field>

        <md-field>
          <label>Correo</label>
          <md-input :value="currentEmployee.email" disabled></md-input>
          <!-- <span class="md-error" v-if="!$v.email.required">Correo es requerido</span> -->
          <!-- <span class="md-error" v-if="!$v.email.email">Dirección email no válida</span> -->
        </md-field>

        <md-field v-show="false">
          <label ref="fileContract">Single</label>
          <md-file v-model="contract" @md-change="uploadFile($event)" />
        </md-field>
        <md-button
          class="md-dense md-raised md-primary employee__user-contrato"
          @click="triggerUpload"
        >
          <img :src="require('@/assets/img/attachment.svg')" alt v-if="!isContractUp" />
          <img
            class="contract-checked"
            :src="require('@/assets/img/check.svg')"
            alt
            v-else
          />
          Adjuntar contrato
        </md-button>
        <md-button
          class="md-dense md-raised md-primary employee__user-contrato"
          v-if="isContractUp"
        >
          Descargar contrato
        </md-button>
      </div>

      <div class="employee__data">
        <md-field>
          <label>Fecha de Ingreso</label>
          <md-input v-model="admittedAt" disabled></md-input>
        </md-field>

        <md-field>
          <label>Ocupación</label>
          <md-input
            v-model="currentEmployee.tregister.occupationLabel"
            disabled
          ></md-input>
        </md-field>

        <md-field>
          <label>Sueldo</label>
          <span class="md-prefix">S/</span>
          <md-input
            v-model="currentEmployee.tregister.grossSalary"
            disabled
            v-decimal
          ></md-input>
          <!-- <span class="md-error" v-if="!$v.sueldo.required">Sueldo es requerido</span> -->
          <!-- <span class="md-error" v-if="!$v.sueldo.isMoney">Monto no válido</span> -->
        </md-field>

        <md-field>
          <label>Régimen Salud</label>
          <md-select :value="currentEmployee.tregister.healthRegime" disabled>
            <md-option value="00">EsSalud Regular(Exclusivo)</md-option>
            <md-option value="01">EsSalud Regular Y EPS/Serv. Prop.</md-option>
            <md-option value="05">EsSalud Pensionistas</md-option>
            <md-option value="20">Sanidad FFAA y Policiales</md-option>
            <md-option value="21">SIS - Microempresa</md-option>
          </md-select>
        </md-field>

        <md-field>
          <label>Régimen Pensionario</label>
          <md-select :value="currentEmployee.tregister.pensionSystem" disabled>
            <md-option value="02">ONP Sistema Nacional de Pensiones</md-option>
            <md-option value="21">SPP Integra</md-option>
            <!-- <md-option value="22">SPP Horizonte</md-option> -->
            <md-option value="23">SPP ProFuturo</md-option>
            <md-option value="24">SPP Prima</md-option>
            <md-option value="25">SPP Habitat</md-option>
          </md-select>
        </md-field>
        <!-- <md-checkbox v-model="disabledQuinta">Desabilitar calculo de 5ta</md-checkbox>  -->
        <!-- <md-button class="md-dense md-raised md-primary employee__data-save" @click="save">Guardar</md-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  alpha,
  email,
  alphaNum,
  numeric,
  helpers,
} from "vuelidate/lib/validators";

const isAlpha = helpers.regex("alpha", /^[a-zA-ZÀ-ÿñÑ ]*$/);
const isPhone = helpers.regex("numeric", /^9[0-9]{8}$/);
const isMoney = helpers.regex("numeric", /^[0-9]+(\.[0-9]{1,2})?$/);

export default {
  name: "DatosPersonales",
  data() {
    return {
      contract: null,
      contractFile: null,
      isContractUp: false,
      documentTypes: {
        "01": "DNI",
        "04": "CARNÉ DE EXTRANJERÍA",
        "07": "PASAPORTE",
        23: "PTP",
      },
    };
  },
  async beforeCreate() {
    if (this.$store.getters.listEmploy.length === 0) {
      this.$store.dispatch("getEmployees", {
        id: window.localStorage.getItem("businessID"),
        page: 1,
      });
    }
  },
  computed: {
    currentEmployee() {
      return this.$store.getters.currentEmployee(this.$route.params.id);
    },
    fullName() {
      if (!this.currentEmployee) return "";
      return `${this.currentEmployee.firstName} ${this.currentEmployee.firstSurname} ${this.currentEmployee.secondSurname}`;
    },
    admittedAt() {
      if (!this.currentEmployee) return "";
      return new Date(this.currentEmployee.tregister.admittedAt).toLocaleDateString();
    },
  },
  methods: {
    triggerUpload() {
      console.log("tratando de que funque el input file");
      this.$refs.fileContract.click();
    },
    uploadFile($event) {
      console.log($event);

      var fr = new FileReader();
      if (!!$event) {
        fr.readAsDataURL($event[0]);

        fr.onload = (fr) => {
          console.log("Loading");
          this.contractFile = $event[0];
          this.$store
            .dispatch("uploadContract", {
              id: this.item.id,
              file: this.contractFile,
            })
            .then((res) => {
              if (res.status == 200) {
                this.isContractUp = true;
              }
            });
        };
        fr.onabort = (fr) => {
          console.log("abort");
        };
        fr.onerror = (fr) => {
          console.log("error");
        };
      }
    },
    save() {
      console.log("boton de guardar data del empleado");

      console.log(this.item);

      // this.$store.dispatch("updateEmployeeData", {
      //   id: this.item.id,
      //   body: {
      //     phone: this.phone,
      //     email: this.email,
      //     disable5ta: this.disabledQuinta
      //   }
      // }).then(res =>{
      //   this.$store.dispatch("getEmployees", {
      //     id: window.localStorage.getItem("businessID"),
      //     page: 1
      //   })
      // })
    },
  },
  filters: {
    phoneNumber(value) {
      value = value.toString();
      return value.slice(0, 3) + " " + value.slice(3, 6) + " " + value.slice(6, 9);
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mqwh($min-width, $max-height) {
  @media (min-width: $min-width) and (max-height: $max-height) {
    @content;
  }
}

@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//8-TRUMPS
//vue-material
.md-field {
  width: 15rem;
  // margin: 0 3rem 2rem 3rem;
  @include mq($sm) {
    width: 21rem;
  }

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

.employee {
  &__wrapper {
    padding: 3rem 0.5rem 2rem 0.5rem;

    @include mqwh($md, 700px) {
      height: 100%;
    }

    @include mq($lg) {
      // overflow-y: visible;
      display: flex;
      flex-wrap: wrap;
      // justify-content: center;
      align-items: center;
      padding: 0;
      margin-top: 0;

      & > div {
        margin: 0 3rem;
      }
    }

    .icon-close {
      position: absolute;
      top: 0.6rem;
      right: 0.6rem;
      font-size: 2rem;
      color: $b-orange;
      @include mq($lg) {
        font-size: 3rem;
        top: 1rem;
        right: 1rem;
        cursor: pointer;
      }
    }
  }

  &__user {
    display: flex;
    flex-direction: column;
    align-items: center;
    &-img {
      height: 12rem;
      width: 12rem;
      border-radius: 100%;
      background-color: #fff;
      margin-bottom: 3rem;
      box-shadow: 3px 6px 15px rgba(#000000, 0.5);
      @include mq($sm) {
        height: 15rem;
        width: 15rem;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 100%;
      }
    }

    &-contrato {
      height: 3rem !important;
      width: 15rem !important;
      background-color: $b-emph !important;
    }
  }

  &__data {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 3rem;
    padding-bottom: 6rem;
    @include mq($lg) {
      padding-bottom: 0;
      margin-top: 0;
    }

    &-save {
      margin-top: 3rem;
      height: 3rem !important;
      width: 15rem !important;
      background-color: $b-orange !important;
      @include mq($lg) {
        margin-top: 0;
      }
    }
  }
  .contract-checked {
    height: 13px;
    color: #ffffff;
    margin-bottom: 2px;
    margin-right: 2px;
  }
}
</style>
